import { render, staticRenderFns } from "./StuRegister.vue?vue&type=template&id=6365bbe2&scoped=true&"
import script from "./sturegister?vue&type=script&lang=js&"
export * from "./sturegister?vue&type=script&lang=js&"
import style0 from "./StuRegister.vue?vue&type=style&index=0&id=6365bbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365bbe2",
  null
  
)

export default component.exports